export  enum ScreenSize{
    Desktop = 0,
    Tablet = 1,
    Mobile = 2
}
